"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_KEY = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var formik_1 = require("formik");
var react_1 = tslib_1.__importStar(require("react"));
var components_1 = require("../../components");
var utils_1 = tslib_1.__importDefault(require("../../components/CreditCard/utils"));
var types_1 = require("../../types");
exports.SECTION_KEY = 'paymentDetails';
var PaymentDetails = function (props) {
    var onCancel = props.onCancel, onSubmit = props.onSubmit, skipMountingScript = props.skipMountingScript, environment = props.environment, guid = props.guid, accountDetails = props.accountDetails, isUnAuthenticated = props.isUnAuthenticated;
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = react_1.useState(false), isCardValid = _b[0], setIsCardValid = _b[1];
    var _c = react_1.useState(types_1.PaymentCardType.EMPTY), cardType = _c[0], setCardType = _c[1];
    var _d = react_1.useContext(asg_1.StepsContext), goToStep = _d.goToStep, completeStep = _d.completeStep;
    var _e = formik_1.useFormikContext(), errors = _e.errors, dirty = _e.dirty;
    var currentStepKey = 'step1';
    var nextStepKey = 'step2';
    var hasPaymentDetailsError = (errors === null || errors === void 0 ? void 0 : errors.paymentDetails) !== undefined || !isCardValid;
    var apacBamboraTestUrl = environment === types_1.Environment.Production
        ? 'https://customcheckout.bambora.com.au/2.0.0/customcheckout.js'
        : 'https://customcheckout-uat.bambora.net.au/2.0.0/customcheckout.js';
    var _f = react_1.useState(null), instance = _f[0], setInstance = _f[1];
    var ready = utils_1.default(apacBamboraTestUrl, skipMountingScript)[0];
    var responsiveSize = react_1.useContext(asg_1.ResponsiveContext);
    react_1.useEffect(function () {
        if (ready) {
            setInstance(window.customcheckout());
        }
    }, [ready]);
    if (ready && instance) {
        return (react_1.default.createElement(components_1.Content, tslib_1.__assign({}, {
            header: {
                hide: false,
                title: 'Make a payment'
            },
            footer: {
                hide: false,
                leftButton: {
                    label: 'Cancel',
                    disabled: loading ? true : false,
                    onClick: onCancel
                },
                rightButton: {
                    label: 'Continue',
                    loading: loading,
                    disabled: dirty === false || hasPaymentDetailsError,
                    onClick: function () {
                        setLoading(true);
                        try {
                            instance.createOneTimeToken(guid, function (result) {
                                if (result.code > 200) {
                                    onSubmit(result, cardType);
                                    completeStep(currentStepKey);
                                    setLoading(false);
                                    goToStep(nextStepKey);
                                }
                            });
                        }
                        catch (e) {
                            setLoading(false);
                        }
                    }
                }
            }
        }),
            react_1.default.createElement(asg_1.Heading, { level: "3" }, "Payment details"),
            react_1.default.createElement(asg_1.Box, { maxWidth: "704px !important", margin: { vertical: responsiveSize === 'xs' ? 'small' : 'medium' } },
                !isUnAuthenticated && accountDetails ? react_1.default.createElement(components_1.AccountCard, tslib_1.__assign({}, accountDetails)) : react_1.default.createElement(components_1.UnAuthenticatedDetails, null),
                react_1.default.createElement(components_1.PaymentAmount, { disabled: loading }),
                isUnAuthenticated && react_1.default.createElement(components_1.EmailAddress, null)),
            react_1.default.createElement(asg_1.Heading, { level: "3" }, "Payment method"),
            react_1.default.createElement(components_1.CreditCard, { sectionKey: exports.SECTION_KEY, instance: instance, onError: function () { return setIsCardValid(false); }, onComplete: function (cardType) {
                    setIsCardValid(true);
                    setCardType(cardType);
                }, disabled: loading })));
    }
    return null;
};
exports.default = PaymentDetails;
//# sourceMappingURL=PaymentDetails.js.map